webpackJsonp([4,7],{

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repricing_vue__ = __webpack_require__(558);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84eaa828_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Repricing_vue__ = __webpack_require__(620);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84eaa828"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84eaa828_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Repricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TenantJobRepricing_vue__ = __webpack_require__(695);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9eed4a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TenantJobRepricing_vue__ = __webpack_require__(876);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TenantJobRepricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9eed4a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TenantJobRepricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(462));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(461));

var _alphaNum = _interopRequireDefault(__webpack_require__(464));

var _numeric = _interopRequireDefault(__webpack_require__(465));

var _between = _interopRequireDefault(__webpack_require__(466));

var _email = _interopRequireDefault(__webpack_require__(467));

var _ipAddress = _interopRequireDefault(__webpack_require__(468));

var _macAddress = _interopRequireDefault(__webpack_require__(469));

var _maxLength = _interopRequireDefault(__webpack_require__(470));

var _minLength = _interopRequireDefault(__webpack_require__(471));

var _required = _interopRequireDefault(__webpack_require__(472));

var _requiredIf = _interopRequireDefault(__webpack_require__(473));

var _requiredUnless = _interopRequireDefault(__webpack_require__(474));

var _sameAs = _interopRequireDefault(__webpack_require__(475));

var _url = _interopRequireDefault(__webpack_require__(476));

var _or = _interopRequireDefault(__webpack_require__(477));

var _and = _interopRequireDefault(__webpack_require__(478));

var _not = _interopRequireDefault(__webpack_require__(479));

var _minValue = _interopRequireDefault(__webpack_require__(480));

var _maxValue = _interopRequireDefault(__webpack_require__(481));

var _integer = _interopRequireDefault(__webpack_require__(482));

var _decimal = _interopRequireDefault(__webpack_require__(483));

var helpers = _interopRequireWildcard(__webpack_require__(458));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets.s3-ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(463).withParams : __webpack_require__(230).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id", "header", "content", "closeIcon", "cancelLabel", "submitLabel", "color", "icon", "subContent"],
  computed: {
    hasCloseIcon: function hasCloseIcon() {
      return this.closeIcon && this.closeIcon === true ? true : false;
    },
    hasCancel: function hasCancel() {
      return this.cancelLabel && this.cancelLabel !== "";
    },
    hasSubmit: function hasSubmit() {
      return this.submitLabel && this.submitLabel !== "";
    },
    getId: function getId() {
      return this.id && this.id !== "" ? this.id : "confirmmodal";
    },
    getColor: function getColor() {
      return this.color && this.color !== "" ? this.color : "confirm-icon";
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== "" ? this.icon : "ic-check";
    }
  },
  methods: {
    closeModal: function closeModal() {
      $("#" + this.getId).modal("hide");
    },
    cancel: function cancel() {
      this.$emit("onCancel");
    },
    submit: function submit() {
      $("#" + this.getId).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d2fd5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(492);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73d2fd5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d2fd5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(491);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("75295075", content, true, {});

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".note-content[data-v-73d2fd5a]{font-size:13px;color:#999}.modal-header-confirm[data-v-73d2fd5a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:15px}", "", {"version":3,"sources":["/app/src/components/shared/ConfirmModal.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACf","file":"ConfirmModal.vue","sourcesContent":["\n.note-content[data-v-73d2fd5a] {\n  font-size: 13px;\n  color: #999;\n}\n.modal-header-confirm[data-v-73d2fd5a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.getId}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[(_vm.hasCloseIcon)?_c('div',{staticClass:"modal-header-confirm"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[(_vm.icon === 'ic-warning')?[_c('svg',{staticClass:"warning-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 20 20"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M8.686 2.852L2.127 14.777A1.5 1.5 0 0 0 3.441 17H16.56a1.5 1.5 0 0 0 1.314-2.223L11.314 2.852a1.5 1.5 0 0 0-2.628 0zM10 6.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75zm.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0z","fill":"currentColor"}})])])]:[_c('div',{class:_vm.getColor},[_c('i',{class:_vm.getIcon})])],_vm._v(" "),_c('header',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.subContent)?_c('div',{staticClass:"note-content"},[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.hasCancel)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelLabel)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasSubmit)?_c('button',{staticClass:"btn btn-primary text-cap",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  "+_vm._s(_vm.submitLabel)+"\n                ")]):_vm._e()])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(53);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(495), __esModule: true };

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33);
__webpack_require__(25);
module.exports = __webpack_require__(496);


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var get = __webpack_require__(54);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/shop/reservations";

/* harmony default export */ __webpack_exports__["a"] = ({
  getById: function getById(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + id).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/create", request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  uploadSignage: function uploadSignage(payload) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/signage", payload).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  updateSignage: function updateSignage(reservationId, payload) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/" + reservationId + "/signage", payload).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  deleteSignage: function deleteSignage(reservationId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + "/" + reservationId + "/signage").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  cancel: function cancel(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/cancel", request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  postFeedback: function postFeedback(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/feedback", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  postNotes: function postNotes(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/note", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  repricing: function repricing(reservationId) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/repricing-detail").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getAvailableAncillaries: function getAvailableAncillaries(reservationId) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/ancillaries").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  submitRepricing: function submitRepricing(reservationId, payload) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/" + reservationId + "/reprice", payload).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt("return", _context11.sent);

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  getRepricingHistory: function getRepricingHistory(reservationId) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/repricing-history").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  getRepricingLog: function getRepricingLog(reservationId, id) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/repricing-log/" + id).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context13.abrupt("return", _context13.sent);

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  closeReservation: function closeReservation(reservationId) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/" + reservationId + "/close").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context14.abrupt("return", _context14.sent);

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  }
});

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var _autocomplete;
var _sessionToken;
var _placesService;

var MaverickAutoComplete = function () {
  function MaverickAutoComplete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MaverickAutoComplete);

    _autocomplete = new google.maps.places.AutocompleteService();
    _sessionToken = new google.maps.places.AutocompleteSessionToken();
    _placesService = new google.maps.places.PlacesService(document.createElement("div"));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MaverickAutoComplete, [{
    key: 'getPredictions',
    value: function getPredictions(keyword, callback, options) {
      if (!_sessionToken) {
        this.refreshToken();
      }
      // only trigger google service when char is more than equal to 3
      if (keyword.length >= 3) {
        var request = {
          input: keyword,
          sessionToken: _sessionToken
        };
        if (options && options.country) {
          request.componentRestrictions = {
            'country': options.country
          };
        }
        _autocomplete.getPlacePredictions(request, function (predictions, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            callback(predictions);
          }
        });
      }
    }
  }, {
    key: 'getPlace',
    value: function getPlace(prediction, callback) {
      var _this = this;

      var request = {
        placeId: prediction.place_id,
        fields: ['name', 'formatted_address', 'geometry', 'address_component'],
        sessionToken: _sessionToken
      };
      _placesService.getDetails(request, function (place, status) {
        // renew session token everytime place details has been requested
        _this.refreshToken();

        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var country = '';
          for (var i = place.address_components.length - 1; i >= 0; i--) {
            if (place.address_components[i].types.find(function (x) {
              return x.toLowerCase() === 'country';
            }) !== undefined) {
              country = place.address_components[i].short_name;
              break;
            }
          }
          callback({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            name: place.name,
            address: place.name + ', ' + place.formatted_address,
            country: country
          });
        }
      });
    }
  }, {
    key: 'refreshToken',
    value: function refreshToken() {
      _sessionToken = new google.maps.places.AutocompleteSessionToken();
    }
  }]);

  return MaverickAutoComplete;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickAutoComplete);

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_ConfirmModal__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_FormPreBooking__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_FormPostBooking__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_ModalConfirmUpdate__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_shop_reservation_inquiryReservationService_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_master_fareComponent_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_google_autocomplete_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__models_constants__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_numberHelper_js__ = __webpack_require__(55);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var labelBooking = {
  postBookingText: "post-booking",
  preBookingText: "pre-booking"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormPreBooking: __WEBPACK_IMPORTED_MODULE_9__components_shared_FormPreBooking__["a" /* default */],
    FormPostBooking: __WEBPACK_IMPORTED_MODULE_10__components_shared_FormPostBooking__["a" /* default */],
    ModalConfirmUpdate: __WEBPACK_IMPORTED_MODULE_11__components_shared_ModalConfirmUpdate__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_8__components_shared_ConfirmModal__["a" /* default */]
  },
  data: function data() {
    return {
      autocomplete: null,
      durationValue: [],
      isLoading: false,
      ancillaries: [],
      reservation: null,
      currencyCode: null,
      commission: null,
      extraPreBooking: [],
      masterPreBookingComponents: [],
      preBookingComponents: [],
      tempDataEditComponent: null,
      extraPostBooking: [],
      masterExtraServices: [],
      extraServices: [],
      tempDataEditExtra: null,
      currencyLocale: "en-US",
      currencyPrecision: 2,
      msg: "Please wait ...",
      minHourly: 0,
      differentLocation: false,
      model: {
        serviceType: "Unspecified",
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        pickUpDate: null,
        dropOffDate: null
      }
    };
  },

  computed: {
    showDropOffLocation: function showDropOffLocation() {
      if (this.model.serviceType === "Rental") {
        return this.differentLocation;
      } else {
        return true;
      }
    },
    isAirportTransfer: function isAirportTransfer() {
      return this.reservation && this.reservation.serviceType === __WEBPACK_IMPORTED_MODULE_15__models_constants__["m" /* ServiceType */].AirportTransferText;
    },
    preBookingBuyingTotal: function preBookingBuyingTotal() {
      return this.preBookingComponents.length > 0 && this.preBookingComponents.reduce(function (initial, val) {
        return initial + val.buyingRate;
      }, 0);
    },
    preBookingSellingTotal: function preBookingSellingTotal() {
      return this.preBookingComponents.length > 0 && this.preBookingComponents.reduce(function (initial, val) {
        return initial + val.sellingRate;
      }, 0);
    },
    postBookingBuyingTotal: function postBookingBuyingTotal() {
      return this.extraServices.length > 0 && this.extraServices.reduce(function (initial, val) {
        return initial + val.buyingRate;
      }, 0);
    },
    postBookingSellingTotal: function postBookingSellingTotal() {
      return this.extraServices.length > 0 && this.extraServices.reduce(function (initial, val) {
        return initial + val.sellingRate;
      }, 0);
    },
    grandBuyingTotal: function grandBuyingTotal() {
      return this.preBookingBuyingTotal + this.postBookingBuyingTotal;
    },
    grandSellingTotal: function grandSellingTotal() {
      return this.preBookingSellingTotal + this.postBookingSellingTotal;
    },
    totalCommission: function totalCommission() {
      var booker = this.commission.booker && this.commission.booker.amount;
      var masterFranchise = this.commission.masterFranchise && this.commission.masterFranchise.amount;
      var operator = this.commission.operator && this.commission.operator.amount;
      return booker + masterFranchise + operator;
    },
    profitTotal: function profitTotal() {
      return this.grandSellingTotal - this.grandBuyingTotal - this.totalCommission;
    },
    preBookingText: function preBookingText() {
      return labelBooking.preBookingText;
    },
    postBookingText: function postBookingText() {
      return labelBooking.postBookingText;
    },
    preBookingEdited: function preBookingEdited() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.preBookingComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.isEdited) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    postBookingEdited: function postBookingEdited() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.extraServices), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.isEdited) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return true;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, minHourly, tempDurationList, i, preBooking, dataAncillaries, dataPreBooking, postBooking;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;
              minHourly = publicSettings.find(function (val) {
                return val.key === "MinimumHourlyHire";
              });

              _this.minHourly = minHourly.value;
              tempDurationList = [];

              for (i = minHourly.value; i <= 24; i++) {
                tempDurationList.push(Number(i));
              }
              _this.durationValue = tempDurationList;

              _context.next = 11;
              return new __WEBPACK_IMPORTED_MODULE_14__plugins_google_autocomplete_js__["a" /* default */]();

            case 11:
              _this.autocomplete = _context.sent;
              _context.next = 14;
              return _this.getRepricing();

            case 14:
              _context.next = 16;
              return _this.getAvailableAncillaries();

            case 16:
              _this.ancillaries = _context.sent;
              _context.next = 19;
              return _this.getPreBookingComponent();

            case 19:
              preBooking = _context.sent;
              dataAncillaries = _this.ancillaries.map(function (val) {
                return {
                  label: val.name,
                  value: val.name
                };
              });
              dataPreBooking = preBooking.map(function (val) {
                return {
                  label: val,
                  value: val
                };
              });

              _this.extraPreBooking = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(dataAncillaries), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(dataPreBooking));
              _context.next = 25;
              return _this.getPostBookingComponent();

            case 25:
              postBooking = _context.sent;

              _this.extraPostBooking = postBooking.map(function (val) {
                return {
                  label: val === __WEBPACK_IMPORTED_MODULE_15__models_constants__["j" /* PostBookingItem */].fareParkingLabel ? "Parking" : val === __WEBPACK_IMPORTED_MODULE_15__models_constants__["j" /* PostBookingItem */].fareTollLabel ? "Tolls" : val,
                  value: val
                };
              });
              _this.$nextTick(function () {
                return _this.sortingData();
              });
              _this.isLoading = false;

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    document.addEventListener("click", function (event) {
      $.each($("#search-form-wrapper .list-autoComplete, #search-form-wrapper .popularCity"), function (index, value) {
        value.classList.remove("isOpen");
      });

      if ($("#search-form-wrapper .searchBox__input-from").is(event.target)) {
        var searchResult = $(event.target.parentElement).find(".list-autoComplete");
        var popularCity = $(event.target.parentElement).find(".popularCity");
        if (searchResult.length > 0 && searchResult[0].getElementsByTagName("li").length > 0) {
          searchResult[0].classList.add("isOpen");
        } else if (popularCity.length > 0 && popularCity[0].getElementsByTagName("li").length > 0) {
          popularCity[0].classList.add("isOpen");
        }
      }
    });

    document.addEventListener("click", function (event) {
      var rentTimeWrapper = document.querySelector("#rentTime-wrapper");
      if (rentTimeWrapper) {
        if (rentTimeWrapper.contains(event.target) && !event.target.parentElement.classList.contains("apply-renttime")) {
          document.querySelector(".rentTime-box").classList.remove("hidden");
        } else {
          document.querySelector(".rentTime-box").classList.add("hidden");
        }
      }
    });
  },

  methods: {
    onFocusAutoComplete: function onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete: function onBlurAutoComplete(target) {
      if (target.name === "pick-up-location") target.value = this.model.pickUpLocation.name;else target.value = this.model.dropOffLocation.name;
    },
    onKeyupAutoComplete: function onKeyupAutoComplete(target) {
      var self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(function (_) {
        var element = void 0;

        if (target.name === "pick-up-location") {
          element = document.getElementById("autoComplete-pickupResults");
        } else {
          element = document.getElementById("autoComplete-dropoffResults");
        }

        // reset suggestion result
        element.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          element.parentElement.classList.remove("isOpen");
          return;
        }
        // const options = {
        //   country: this.searchParameter.pickUpLocation.country,
        // };
        self.autocomplete.getPredictions(target.value, function (predictions) {
          // loop result
          predictions.forEach(function (prediction) {
            var item = document.createElement("li");
            item.className = "list-result-autocomplete";
            item.innerHTML = self.$helper.getPlaceIcon(prediction.types) + "<div><div class='point-of-view'>" + prediction.structured_formatting.main_text + "</div><span class='address-list-autocomplete'>" + prediction.structured_formatting.secondary_text + "</span></div>";
            item.addEventListener("click", function (_) {
              return self.getPlace(target, prediction);
            });
            element.appendChild(item);
          });
          // show the result
          element.parentElement.classList.add("isOpen");
        }
        // options // this code for country (not mandatory)
        );
      }, 200);
    },
    getPlace: function getPlace(target, prediction) {
      var self = this;
      self.autocomplete.getPlace(prediction, function (place) {
        var isAirportZone = prediction.types.includes("airport") ? true : false;

        if (target.name === "pick-up-location") {
          self.model.pickUpLocation = {
            latitude: place.latitude,
            longitude: place.longitude,
            name: place.name,
            address: place.address,
            country: place.country,
            isAirportZone: isAirportZone
          };
        } else {
          self.model.dropOffLocation = {
            latitude: place.latitude,
            longitude: place.longitude,
            name: place.name,
            address: place.address,
            country: place.country,
            isAirportZone: isAirportZone
          };
        }
        // everytime user select the prediction, result list should be reset
        document.getElementById("autoComplete-pickupResults").innerHTML = "";
        document.getElementById("autoComplete-dropoffResults").innerHTML = "";
      });
    },
    onChangeServiceType: function onChangeServiceType(val) {
      this.model.serviceType = val;
    },
    sortingData: function sortingData() {
      var _this2 = this;

      var baseData = [];
      var ancillariesData = [];
      var surchargesData = [];
      var baseDataMaster = [];
      var ancillariesDataMaster = [];
      var surchargesDataMaster = [];

      this.preBookingComponents.forEach(function (val) {
        if (val.name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].baseLabel || val.name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].markupLabel) {
          baseData.push(val);
          return;
        }

        var findAncill = _this2.ancillaries.find(function (el) {
          return el.name === val.name;
        });
        if (findAncill) {
          ancillariesData.push(val);
        } else {
          surchargesData.push(val);
        }
      });

      baseData.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.$nextTick(function () {
        return _this2.preBookingComponents = baseData.concat(surchargesData.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        })).concat(ancillariesData.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        }));
      });

      this.masterPreBookingComponents.forEach(function (val) {
        if (val.name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].baseLabel || val.name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].markupLabel) {
          baseDataMaster.push(val);
          return;
        }

        var findAncillMaster = _this2.ancillaries.find(function (el) {
          return el.name === val.name;
        });
        if (findAncillMaster) {
          ancillariesDataMaster.push(val);
        } else {
          surchargesDataMaster.push(val);
        }
      });

      baseDataMaster.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.$nextTick(function () {
        return _this2.masterPreBookingComponents = baseDataMaster.concat(surchargesDataMaster.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        })).concat(ancillariesDataMaster.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        }));
      });
    },
    getRepricing: function getRepricing() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, equal, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__services_shop_reservation_inquiryReservationService_js__["a" /* default */].repricing(_this3.$route.params.id);

              case 3:
                response = _context2.sent;
                equal = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEqual(response.pickUpLocation, response.dropOffLocation);


                _this3.differentLocation = equal ? false : true;

                _this3.reservation = {
                  paymentStatus: response.paymentStatus,
                  paymentMethodDescription: response.paymentMethodDescription,
                  reservationDate: response.reservationDate,
                  code: response.reservationCode,
                  serviceType: response.serviceType
                };

                _this3.model = {
                  serviceType: response.serviceType,
                  pickUpLocation: response.pickUpLocation,
                  dropOffLocation: response.dropOffLocation,
                  pickUpDate: {
                    date: response.pickUpDate.year + "-" + response.pickUpDate.stringMonth + "-" + response.pickUpDate.stringDate,
                    time: response.pickUpDate.stringHour + ":" + response.pickUpDate.stringMinute
                  },
                  dropOffDate: {
                    date: response.dropOffDate.year + "-" + response.dropOffDate.stringMonth + "-" + response.dropOffDate.stringDate,
                    time: response.dropOffDate.stringHour + ":" + response.dropOffDate.stringMinute
                  },
                  durationInHour: response.serviceType === "Rental" ? response.durationInMinutes / 60 : _this3.minHourly
                };

                if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(_this3.model.durationInHour)) {
                  _this3.model.durationInHour = Math.round(_this3.model.durationInHour);
                }

                _this3.commission = response.commission;
                _this3.masterPreBookingComponents = response.preBookingComponents;
                _this3.masterExtraServices = response.extraServices;
                _this3.preBookingComponents = response.preBookingComponents.map(function (val) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, val, { isEdited: false });
                });
                _this3.extraServices = response.extraServices.map(function (val) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, val, {
                    isEdited: false
                  });
                });
                _this3.currencyCode = response.preBookingComponents[0].currency;
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this3.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 17]]);
      }))();
    },
    getAvailableAncillaries: function getAvailableAncillaries() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__services_shop_reservation_inquiryReservationService_js__["a" /* default */].getAvailableAncillaries(_this4.$route.params.id);

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", response);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this4.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },
    getPreBookingComponent: function getPreBookingComponent() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__services_master_fareComponent_js__["a" /* default */].getPreBookingComponent();

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", response);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this5.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7]]);
      }))();
    },
    getPostBookingComponent: function getPostBookingComponent() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__services_master_fareComponent_js__["a" /* default */].getPostBookingComponent();

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", response);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this6.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 7]]);
      }))();
    },
    isDropOffDateInvalid: function isDropOffDateInvalid(pickUpDate, dropOffDate) {
      var pickUp = new Date(pickUpDate.date + "T" + pickUpDate.time);
      var dropOff = new Date(dropOffDate.date + "T" + dropOffDate.time);

      return pickUp >= dropOff;
    },
    onSubmit: function onSubmit() {
      var _this7 = this;

      var confirm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _payload, date, pickUp, dropOff, payload, response, index;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!confirm && _this7.reservation.serviceType !== _this7.model.serviceType)) {
                  _context6.next = 3;
                  break;
                }

                $("#ConfirmationModal").modal({
                  backdrop: "static",
                  keyboard: false
                });
                return _context6.abrupt("return");

              case 3:

                // const isDropOffDateInvalid = this.isDropOffDateInvalid(
                //   this.model.pickUpDate,
                //   this.model.dropOffDate
                // );

                // if (
                //   this.model.serviceType === ServiceType.AirportTransferText &&
                //   isDropOffDateInvalid
                // ) {
                //   const message =
                //     "Drop-off date time can't be lower than the pick-up date time.";
                //   const buttonProcess = false;
                //   this.$eventBus.$emit(
                //     "ConfirmEdit",
                //     "idx",
                //     message,
                //     "warning",
                //     buttonProcess
                //   );
                //   return;
                // }

                _this7.isLoading = true;
                _context6.prev = 4;
                date = void 0;


                if (_this7.model.serviceType === "Rental") {
                  date = Object(__WEBPACK_IMPORTED_MODULE_16__helpers_numberHelper_js__["a" /* calculateDropOffDate */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this7.model.pickUpDate, {
                    durationInHour: _this7.model.durationInHour
                  }));
                } else {
                  pickUp = Object(__WEBPACK_IMPORTED_MODULE_16__helpers_numberHelper_js__["b" /* convertDateTime */])(_this7.model.pickUpDate);
                  dropOff = Object(__WEBPACK_IMPORTED_MODULE_16__helpers_numberHelper_js__["b" /* convertDateTime */])(_this7.model.dropOffDate);


                  date = { pickUp: pickUp, dropOff: dropOff };
                }

                payload = (_payload = {
                  serviceType: _this7.model.serviceType,
                  pickUpLocation: _this7.model.pickUpLocation,
                  dropOffLocation: _this7.model.dropOffLocation,
                  pickUpDate: date.pickUp,
                  dropOffDate: date.dropOff
                }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, "dropOffDate", _this7.model.serviceType === __WEBPACK_IMPORTED_MODULE_15__models_constants__["m" /* ServiceType */].RentalHourlyText ? date.dropOff : null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, "notes", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, "commission", _this7.commission), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, "preBookingComponents", _this7.preBookingComponents), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, "extraServices", _this7.extraServices), _payload);


                if (_this7.model.serviceType === "Rental" && !_this7.differentLocation) {
                  payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
                    dropOffLocation: _this7.model.pickUpLocation
                  });
                }

                _context6.next = 11;
                return __WEBPACK_IMPORTED_MODULE_12__services_shop_reservation_inquiryReservationService_js__["a" /* default */].submitRepricing(_this7.$route.params.id, payload);

              case 11:
                response = _context6.sent;


                if (response.isSuccess) {
                  _this7.$notification.success("Successfully repriced.", {
                    title: "Success"
                  });

                  if (_this7.$route.path.includes("tenant")) {
                    _this7.$router.push({
                      path: "/job/tenant/" + _this7.$route.params.id
                    });
                  } else {
                    _this7.$router.push({
                      path: "/reservation/inquiry/" + _this7.$route.params.id
                    });
                  }
                }
                _context6.next = 18;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6["catch"](4);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this7.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 18:
                _context6.prev = 18;

                _this7.isLoading = false;
                return _context6.finish(18);

              case 21:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[4, 15, 18, 21]]);
      }))();
    },
    onSubmitComponent: function onSubmitComponent(typeBooking, data) {
      var _this8 = this;

      var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, {
        buyingRateId: null,
        currency: this.currencyCode,
        evidenceId: null,
        qty: data.qty ? Number(data.qty) : null,
        referenceId: null,
        sellingRateId: null
      });
      if (typeBooking === this.preBookingText) {
        var find = this.ancillaries.find(function (val) {
          return val.name === data.name;
        });
        if (find) {
          payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, { referenceId: find.id });
        }
        this.masterPreBookingComponents.push(payload);
        this.preBookingComponents.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, { isEdited: false }));

        this.calculateAmountBooker();
        this.calculateAmountMasterFranchise();
        this.calculateAmountOperator();
      }
      if (typeBooking === this.postBookingText) {
        this.masterExtraServices.push(payload);
        this.extraServices.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, { isEdited: false }));
      }

      this.$nextTick(function () {
        return _this8.sortingData();
      });
    },
    onEditComponent: function onEditComponent(val, idx) {
      this.tempDataEditComponent = val;
      this.preBookingComponents[idx].isEdited = !this.preBookingComponents[idx].isEdited;
    },
    deleteFareComponent: function deleteFareComponent(index) {
      this.preBookingComponents = this.preBookingComponents.filter(function (_, idx) {
        return idx !== index;
      });
      this.masterPreBookingComponents = this.masterPreBookingComponents.filter(function (_, idx) {
        return idx !== index;
      });

      this.calculateAmountBooker();
      this.calculateAmountMasterFranchise();
      this.calculateAmountOperator();
    },
    validateConfirmEdit: function validateConfirmEdit(idx, label) {
      var _this9 = this;

      if (label === this.preBookingText) {
        var getAncillary = this.ancillaries.find(function (val) {
          return val.name === _this9.preBookingComponents[idx].name;
        });

        if (getAncillary) {
          if (!this.preBookingComponents[idx].qty) {
            var message = "Minimum quantity must be 1 or more than 1.";
            var buttonProcess = false;
            this.$eventBus.$emit("ConfirmEdit", idx, message, label, buttonProcess);
            return;
          }
        }

        if (this.preBookingComponents[idx].name !== __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].markupLabel && !this.preBookingComponents[idx].buyingRate && !this.preBookingComponents[idx].sellingRate) {
          var _message = "There are no prices entered for both buying and selling. Do you wish to proceed?";
          var _buttonProcess = true;
          this.$eventBus.$emit("ConfirmEdit", idx, _message, label, _buttonProcess);
          return;
        }

        if (this.preBookingComponents[idx].buyingRate > this.preBookingComponents[idx].sellingRate && this.preBookingComponents[idx].name !== __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].markupLabel) {
          var _message2 = "The selling price is lower than the buying price. Do you wish to proceed?";
          var _buttonProcess2 = true;
          this.$eventBus.$emit("ConfirmEdit", idx, _message2, label, _buttonProcess2);
          return;
        }

        if (this.preBookingComponents[idx].name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["k" /* PreBookingItem */].markupLabel && !this.preBookingComponents[idx].sellingRate) {
          var _message3 = "No price entered for selling markup. Please check again.";
          var _buttonProcess3 = false;
          this.$eventBus.$emit("ConfirmEdit", idx, _message3, label, _buttonProcess3);
          return;
        }

        this.onConfirmEditComponent(idx);
      }

      if (label === this.postBookingText) {
        if (this.extraServices[idx].name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["j" /* PostBookingItem */].fareParkingLabel || this.extraServices[idx].name === __WEBPACK_IMPORTED_MODULE_15__models_constants__["j" /* PostBookingItem */].fareTollLabel) {
          if (!this.extraServices[idx].buyingRate) {
            var _message4 = "There are no prices entered for buying rate. Please check again.";
            var _buttonProcess4 = false;
            this.$eventBus.$emit("ConfirmEdit", idx, _message4, label, _buttonProcess4);
            return;
          }
          this.onConfirmEditExtra(idx);
          return;
        }

        if (!this.extraServices[idx].qty) {
          var _message5 = "Minimum quantity must be 1 or more than 1.";
          var _buttonProcess5 = false;
          this.$eventBus.$emit("ConfirmEdit", idx, _message5, label, _buttonProcess5);
          return;
        }

        if (!this.extraServices[idx].buyingRate && !this.extraServices[idx].sellingRate) {
          var _message6 = "There are no prices entered for both buying and selling. Please check again.";
          var _buttonProcess6 = false;
          this.$eventBus.$emit("ConfirmEdit", idx, _message6, label, _buttonProcess6);
          return;
        }

        if (this.extraServices[idx].buyingRate > this.extraServices[idx].sellingRate) {
          var _message7 = "The selling price is lower than the buying price. Do you wish to proceed?";
          var _buttonProcess7 = true;
          this.$eventBus.$emit("ConfirmEdit", idx, _message7, label, _buttonProcess7);
          return;
        }

        this.onConfirmEditExtra(idx);
      }
    },
    submitFromModal: function submitFromModal(idx, label) {
      if (label === this.preBookingText) {
        this.onConfirmEditComponent(idx);
        return;
      }

      if (label === this.postBookingText) {
        this.onConfirmEditExtra(idx);
        return;
      }
    },
    onConfirmEditComponent: function onConfirmEditComponent(idx) {
      var tempData = this.preBookingComponents[idx];
      this.preBookingComponents[idx].isEdited = !this.preBookingComponents[idx].isEdited;
      this.tempDataEditComponent = null;

      if (tempData.name.toLowerCase() === "base" || tempData.name.toLowerCase() === "markup") {
        this.calculateAmountBooker();
        this.calculateAmountMasterFranchise();
        this.calculateAmountOperator();
      }
    },
    onEditExtra: function onEditExtra(val, idx) {
      this.tempDataEditExtra = val;
      this.extraServices[idx].isEdited = !this.extraServices[idx].isEdited;
    },
    deleteExtraService: function deleteExtraService(index) {
      this.extraServices = this.extraServices.filter(function (_, i) {
        return i !== index;
      });
      this.masterExtraServices = this.masterExtraServices.filter(function (_, idx) {
        return idx !== index;
      });

      this.calculateAmountBooker();
      this.calculateAmountMasterFranchise();
      this.calculateAmountOperator();
    },
    onConfirmEditExtra: function onConfirmEditExtra(idx) {
      this.extraServices[idx].isEdited = !this.extraServices[idx].isEdited;
      this.tempDataEditExtra = null;
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    },
    checkQty: function checkQty(i, label) {
      if (label === this.preBookingText) {
        return this.masterPreBookingComponents[i].qty;
      } else {
        return this.masterExtraServices[i].qty;
      }
    },
    checkBuyingRate: function checkBuyingRate(i, label) {
      if (label === this.preBookingText) {
        return this.masterPreBookingComponents[i].buyingRate !== null || this.preBookingComponents[i].name.toLowerCase() !== "markup";
      } else {
        return this.masterExtraServices[i].buyingRate !== null;
      }
    },
    checkSellingRate: function checkSellingRate(i, label) {
      if (label === this.preBookingText) {
        return this.masterPreBookingComponents[i].sellingRate !== null;
      } else {
        return this.masterExtraServices[i].sellingRate !== null;
      }
    },
    openModalPreBooking: function openModalPreBooking() {
      var preBooking = this.getResultArray(this.preBookingComponents, this.extraPreBooking);
      this.$eventBus.$emit("FormPreBooking", preBooking);
    },
    openModalPostBooking: function openModalPostBooking() {
      var postBooking = this.getResultArray(this.extraServices, this.extraPostBooking);
      this.$eventBus.$emit("FormPostBooking", postBooking);
    },
    getResultArray: function getResultArray(dataMaster, dataExtra) {
      var result = [];

      var _loop = function _loop(extraItem) {
        var isMatching = dataMaster.some(function (masterItem) {
          return masterItem.name === extraItem.value;
        });
        if (!isMatching) {
          result.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, extraItem));
        }
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(dataExtra), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var extraItem = _step3.value;

          _loop(extraItem);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return result;
    },
    onClickDurationPicker: function onClickDurationPicker(hours) {
      this.model.durationInHour = hours;
    },
    calculateAmountBooker: function calculateAmountBooker() {
      var findBaseFare = this.preBookingComponents.find(function (val) {
        return val.name.toLowerCase() === "base";
      });

      var findMarkup = this.preBookingComponents.find(function (val) {
        return val.name.toLowerCase() === "markup";
      });

      if (this.commission && this.commission.booker) {
        if (!findMarkup) {
          this.commission.booker.amount = this.commission.booker.isPercentage ? findBaseFare.sellingRate * (this.commission.booker.rate / 100) : this.commission.booker.rate;
          return;
        }

        this.commission.booker.amount = this.commission.booker.isPercentage ? (findBaseFare.sellingRate + findMarkup.sellingRate) * (this.commission.booker.rate / 100) : this.commission.booker.rate;
      }
    },
    calculateAmountMasterFranchise: function calculateAmountMasterFranchise() {
      var findBaseFare = this.preBookingComponents.find(function (val) {
        return val.name.toLowerCase() === "base";
      });

      if (this.commission && this.commission.masterFranchise) {
        this.commission.masterFranchise.amount = this.commission.masterFranchise.isPercentage ? findBaseFare.buyingRate * (this.commission.masterFranchise.rate / 100) : this.commission.masterFranchise.rate;
      }
    },
    calculateAmountOperator: function calculateAmountOperator() {
      var findBaseFare = this.preBookingComponents.find(function (val) {
        return val.name.toLowerCase() === "base";
      });

      if (this.commission && this.commission.operator) {
        this.commission.operator.amount = this.commission.operator.isPercentage ? findBaseFare.buyingRate * (this.commission.operator.rate / 100) : this.commission.operator.rate;
      }
    },
    onChangeQty: function onChangeQty(indexItem, fareComponents, currentFareComponents) {
      var fareComponentItem = fareComponents[indexItem];
      var currentFareComponentItem = currentFareComponents[indexItem];

      fareComponentItem.buyingRate = currentFareComponentItem.buyingRate / currentFareComponentItem.qty * fareComponentItem.qty;

      fareComponentItem.sellingRate = currentFareComponentItem.sellingRate / currentFareComponentItem.qty * fareComponentItem.qty;
    }
  },
  updated: function updated() {
    this.$helper.numbersOnly();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("FormPreBooking");
    this.$eventBus.$off("FormPostBooking");
    this.$eventBus.$off("ConfirmEdit");
  }
});

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_constants__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      isSubmitted: false,
      modelBooking: {
        name: "",
        qty: null,
        buyingRate: null,
        sellingRate: null
      },
      bookingOption: [],
      currencyLocale: "en-US",
      currencyPrecision: 2
    };
  },
  validations: function validations() {
    var v = {
      modelBooking: {
        name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        qty: this.validationQty,
        buyingRate: this.validationBuyingRate,
        sellingRate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };

    return v;
  },

  computed: {
    showQty: function showQty() {
      return this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["k" /* PreBookingItem */].nightHourSurchargeLabel && this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["k" /* PreBookingItem */].peakPeriodSurchargeLabel && this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["k" /* PreBookingItem */].weekendSurchargeLabel && this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["k" /* PreBookingItem */].markupLabel;
    },
    showBuyingRate: function showBuyingRate() {
      return this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["k" /* PreBookingItem */].markupLabel;
    },
    validationQty: function validationQty() {
      return !this.showQty ? {} : { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minValue"])(1) };
    },
    validationBuyingRate: function validationBuyingRate() {
      return !this.showBuyingRate ? {} : { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] };
    }
  },
  created: function created() {
    this.$eventBus.$on("FormPreBooking", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("FormPreBooking");
  },

  methods: {
    initialize: function initialize(bookingOption) {
      var _this = this;

      this.isLoading = true;
      this.isOpen = true;
      this.bookingOption = bookingOption;
      this.modelBooking = {
        name: "",
        qty: null,
        buyingRate: null,
        sellingRate: null
      };
      setTimeout(function () {
        $(_this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false
        });
        _this.isLoading = false;
      }, 1000);
    },
    clearModelBooking: function clearModelBooking() {
      this.modelBooking = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.modelBooking, {
        qty: null,
        buyingRate: null,
        sellingRate: null
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.isSubmitted = true;
      this.$v.modelBooking.$touch();
      if (this.$v.modelBooking.$error) {
        this.$nextTick(function () {
          return _this2.$helper.focusToFieldError();
        });
        return;
      }
      this.$emit("submit", "pre-booking", this.modelBooking);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.isOpen = false;
      this.isSubmitted = false;
      $(this.$refs.extraModal).modal("hide");
    }
  },
  updated: function updated() {
    this.$helper.numbersOnly();
  }
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_constants__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      isSubmitted: false,
      modelBooking: {
        name: "",
        qty: null,
        buyingRate: null,
        sellingRate: null
      },
      bookingOption: [],
      currencyLocale: "en-US",
      currencyPrecision: 2
    };
  },
  validations: function validations() {
    var v = {
      modelBooking: {
        name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        qty: this.validationQty,
        buyingRate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        sellingRate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };

    return v;
  },

  computed: {
    showQty: function showQty() {
      return this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["j" /* PostBookingItem */].fareParkingLabel && this.modelBooking.name !== __WEBPACK_IMPORTED_MODULE_1__models_constants__["j" /* PostBookingItem */].fareTollLabel;
    },
    showMinOnQty: function showMinOnQty() {
      return this.modelBooking.name === __WEBPACK_IMPORTED_MODULE_1__models_constants__["j" /* PostBookingItem */].waitingTimeLabel || this.modelBooking.name === __WEBPACK_IMPORTED_MODULE_1__models_constants__["j" /* PostBookingItem */].overtimeLabel;
    },
    validationQty: function validationQty() {
      return !this.showQty ? {} : { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minValue"])(1) };
    }
  },
  created: function created() {
    this.$eventBus.$on("FormPostBooking", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("FormPostBooking");
  },

  methods: {
    initialize: function initialize(bookingOption) {
      var _this = this;

      this.isLoading = true;
      this.isOpen = true;
      this.bookingOption = bookingOption;
      this.modelBooking = {
        name: "",
        qty: null,
        buyingRate: null,
        sellingRate: null
      };
      setTimeout(function () {
        $(_this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false
        });
        _this.isLoading = false;
      }, 1000);
    },
    clearModelBooking: function clearModelBooking() {
      this.modelBooking = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.modelBooking, {
        qty: null,
        buyingRate: null,
        sellingRate: null
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.isSubmitted = true;
      this.$v.modelBooking.$touch();
      if (this.$v.modelBooking.$error) {
        this.$nextTick(function () {
          return _this2.$helper.focusToFieldError();
        });
        return;
      }

      this.modelBooking = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.modelBooking, {
        qty: this.modelBooking.name === __WEBPACK_IMPORTED_MODULE_1__models_constants__["j" /* PostBookingItem */].fareParkingLabel || this.modelBooking.name === __WEBPACK_IMPORTED_MODULE_1__models_constants__["j" /* PostBookingItem */].fareTollLabel ? 1 : this.modelBooking.qty
      });

      this.$emit("submit", "post-booking", this.modelBooking);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.isOpen = false;
      this.isSubmitted = false;
      $(this.$refs.extraModal).modal("hide");
    }
  },
  updated: function updated() {
    this.$helper.numbersOnly();
  }
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: "",
      index: "",
      label: "",
      buttonProcess: true
    };
  },
  created: function created() {
    this.$eventBus.$on("ConfirmEdit", this.initialize);
  },

  methods: {
    initialize: function initialize(index, message, label, buttonProcess) {
      var _this = this;

      this.index = index;
      this.message = message;
      this.label = label;
      this.buttonProcess = buttonProcess;
      setTimeout(function () {
        $(_this.$refs.repricingEditModal).modal({
          backdrop: "static",
          keyboard: false
        });
      }, 200);
    },
    cancel: function cancel() {
      this.index = null;
      this.message = "";
      $(this.$refs.repricingEditModal).modal("hide");
    },
    submit: function submit() {
      this.$emit("submit", this.index, this.label);
      this.cancel();
    }
  }
});

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(602);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("196f5cd0", content, true, {});

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".service-type-wrapper[data-v-84eaa828]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}h4[data-v-84eaa828]{font-weight:700;font-size:1.2rem}.repricing-table[data-v-84eaa828]{border-collapse:collapse;margin:25px 0;font-size:.9em;width:100%;border-radius:5px 5px 0 0;overflow:hidden;-webkit-box-shadow:0 0 20px rgba(0,0,0,.15);box-shadow:0 0 20px rgba(0,0,0,.15)}.repricing-table thead tr[data-v-84eaa828]{background-color:#a0a0a0;color:#fff;text-align:center;font-weight:700}.repricing-table thead tr th[data-v-84eaa828]:first-child{width:10px}.repricing-table thead tr th[data-v-84eaa828]:nth-child(2){width:25%}.repricing-table thead tr th[data-v-84eaa828]:nth-child(3){width:10%}.repricing-table thead tr th[data-v-84eaa828]:nth-child(4),.repricing-table thead tr th[data-v-84eaa828]:nth-child(5){width:-webkit-max-content;width:-moz-max-content;width:max-content}.repricing-table thead.total-head[data-v-84eaa828]{font-size:1.2em}.repricing-table th[data-v-84eaa828]{font-size:1em;font-weight:900}.repricing-table td[data-v-84eaa828],.repricing-table th[data-v-84eaa828]{padding:12px 15px}.repricing-table tbody tr[data-v-84eaa828]{border-bottom:1px solid #ddd}.repricing-table tbody tr[data-v-84eaa828]:nth-of-type(2n){background-color:#f3f3f3}.repricing-table tbody tr[data-v-84eaa828]:last-of-type{border-bottom:2px solid #a0a0a0}.repricing-table tfoot.tfoot-table[data-v-84eaa828]{font-size:1.1em;font-weight:bolder;color:#009879}.repricing-table td.flex-end[data-v-84eaa828]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}table.commision-table[data-v-84eaa828]{border-collapse:collapse;margin:25px 0;font-size:1.1em;border-radius:5px 5px 0 0;overflow:hidden;font-weight:500}table.commision-table tbody[data-v-84eaa828]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px}table.commision-table tr[data-v-84eaa828]{border-left:4px solid #a0a0a0;border-radius:5px}table.commision-table tr td[data-v-84eaa828]:first-child{padding-left:10px;width:150px}table.commision-table tr td[data-v-84eaa828]:nth-child(2){width:20px}table.commision-table tr td[data-v-84eaa828]:last-child{min-width:120px;text-align:right}button.btn-close-modal[data-v-84eaa828]{padding:8px;border-radius:100%}button.btn-close-modal[data-v-84eaa828]:hover{background:#a0a0a0}button.btn-edit-repricing[data-v-84eaa828]{padding:3px 20px;border-radius:5px;outline:none;border:none;background-color:#fff;border:1px solid #4fb848;color:#4fb848}button.btn-delete-repricing[data-v-84eaa828]{padding:3px 20px;border-radius:5px;outline:none;border:none;background-color:#fff;border:1px solid red;color:red}button.btn-edit-repricing[data-v-84eaa828]:hover{background-color:#4fb848;color:#fff;font-weight:700}button.btn-delete-repricing[data-v-84eaa828]:hover{background-color:red;color:#fff;font-weight:700}button.btn-edit-check[data-v-84eaa828]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:3px 20px;border-radius:5px;outline:none;border:none;background-color:#fff;border:1px solid #4fb848;color:#4fb848}button.btn-edit-check[data-v-84eaa828]:hover{background-color:#4fb848;color:#fff;font-weight:700}button.btn-edit-wrong[data-v-84eaa828]{padding:3px 20px;border-radius:5px;outline:none;border:none;background-color:#fff;border:1px solid red;color:red}button.btn-edit-wrong[data-v-84eaa828]:hover{background-color:red;color:#fff;font-weight:700}.btn.btn-add[data-v-84eaa828]{background:#4fb848;font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:6px 20px;text-transform:uppercase;outline:none}.btn.btn-add[data-v-84eaa828]:hover{background:#339c2b}.btn.btn-submit[data-v-84eaa828]{background:#4fb848}.btn.btn-cancel[data-v-84eaa828],.btn.btn-submit[data-v-84eaa828]{font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-cancel[data-v-84eaa828]{background:#a0a0a0}.btn.btn-submit[data-v-84eaa828]:hover{background:#339c2b}.btn.btn-cancel[data-v-84eaa828]:hover{background:#888}.gap-10[data-v-84eaa828]{gap:10px}span.blue__color[data-v-84eaa828]{color:#5499e4}.repricing_box_date_time[data-v-84eaa828]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;width:70%;padding:10px 20px;border-radius:5px;border:1px solid #ddd;gap:10px;margin:0 auto}.repricing_box_date_time .date_time_box[data-v-84eaa828]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:60%}.repricing_box_date_time .duration_box[data-v-84eaa828]{width:40%}input#repricing-date-time-input.field-input[data-v-84eaa828]{border:none!important;outline:none!important}.repricingTime-box.rentTime-box[data-v-84eaa828]{width:100%;height:300px}.repricing__profit__box[data-v-84eaa828]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;width:100%;height:auto}button svg[data-v-84eaa828]{width:20px}span.svg-empty-box svg[data-v-84eaa828]{width:80px;color:#a0a0a0}h5.label-empty-data[data-v-84eaa828]{font-weight:800;color:#a0a0a0}span.green__color[data-v-84eaa828]{color:#009879}.text-checkbox[data-v-84eaa828]{color:#4a4a4a;font-weight:400}", "", {"version":3,"sources":["/app/src/components/shared/Repricing.vue"],"names":[],"mappings":"AACA,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,UAAY,CACb,AACD,oBACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,kCACE,yBAA0B,AAC1B,cAAe,AACf,eAAiB,AACjB,WAAY,AACZ,0BAA2B,AAC3B,gBAAiB,AACjB,4CAAiD,AACzC,mCAAyC,CAClD,AACD,2CACE,yBAA0B,AAC1B,WAAe,AACf,kBAAmB,AACnB,eAAkB,CACnB,AACD,0DACE,UAAY,CACb,AACD,2DACE,SAAW,CACZ,AACD,2DACE,SAAW,CACZ,AACD,sHAEE,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,mDACE,eAAiB,CAClB,AACD,qCACE,cAAe,AACf,eAAiB,CAClB,AACD,0EAEE,iBAAmB,CACpB,AACD,2CACE,4BAAiC,CAClC,AACD,2DACE,wBAA0B,CAC3B,AACD,wDACE,+BAAiC,CAClC,AACD,oDACE,gBAAiB,AACjB,mBAAoB,AACpB,aAAe,CAChB,AACD,8CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,uCACE,yBAA0B,AAC1B,cAAe,AACf,gBAAiB,AACjB,0BAA2B,AAC3B,gBAAiB,AACjB,eAAiB,CAClB,AACD,6CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,QAAU,CACX,AACD,0CACE,8BAA+B,AAC/B,iBAAmB,CACpB,AACD,yDACE,kBAAmB,AACnB,WAAa,CACd,AACD,0DACE,UAAY,CACb,AACD,wDACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,wCACE,YAAa,AACb,kBAAoB,CACrB,AACD,8CACE,kBAAoB,CACrB,AACD,2CACE,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,sBAAuB,AACvB,yBAAmC,AACnC,aAAwB,CACzB,AACD,6CACE,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,sBAAuB,AACvB,qBAAiC,AACjC,SAAsB,CACvB,AACD,iDACE,yBAAmC,AACnC,WAAY,AACZ,eAAiB,CAClB,AACD,mDACE,qBAAiC,AACjC,WAAY,AACZ,eAAiB,CAClB,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,sBAAuB,AACvB,yBAAmC,AACnC,aAAwB,CACzB,AACD,6CACE,yBAAmC,AACnC,WAAY,AACZ,eAAiB,CAClB,AACD,uCACE,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,sBAAuB,AACvB,qBAAiC,AACjC,SAAsB,CACvB,AACD,6CACE,qBAAiC,AACjC,WAAY,AACZ,eAAiB,CAClB,AACD,8BACE,mBAAoB,AACpB,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,iBAAkB,AAClB,yBAA0B,AAC1B,YAAc,CACf,AACD,oCACE,kBAAoB,CACrB,AACD,iCACE,kBAAoB,CAWrB,AACD,kEAXE,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CAcf,AAZD,iCACE,kBAAoB,CAWrB,AACD,uCACE,kBAAoB,CACrB,AACD,uCACE,eAAoB,CACrB,AACD,yBACE,QAAU,CACX,AACD,kCACE,aAAe,CAChB,AACD,0CACE,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,sBAA0B,AAC1B,SAAU,AACV,aAAe,CAChB,AACD,yDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,SAAW,CACZ,AACD,wDACE,SAAW,CACZ,AACD,6DACE,sBAAwB,AACxB,sBAAyB,CAC1B,AACD,iDACE,WAAY,AACZ,YAAc,CACf,AACD,yCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,WAAY,AACZ,WAAa,CACd,AACD,4BACE,UAAY,CACb,AACD,wCACE,WAAY,AACZ,aAAe,CAChB,AACD,qCACE,gBAAiB,AACjB,aAAe,CAChB,AACD,mCACE,aAAe,CAChB,AACD,gCACE,cAAe,AACf,eAAoB,CACrB","file":"Repricing.vue","sourcesContent":["\n.service-type-wrapper[data-v-84eaa828] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\nh4[data-v-84eaa828] {\n  font-weight: 700;\n  font-size: 1.2rem;\n}\n.repricing-table[data-v-84eaa828] {\n  border-collapse: collapse;\n  margin: 25px 0;\n  font-size: 0.9em;\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n}\n.repricing-table thead tr[data-v-84eaa828] {\n  background-color: #a0a0a0;\n  color: #ffffff;\n  text-align: center;\n  font-weight: bold;\n}\n.repricing-table thead tr th[data-v-84eaa828]:first-child {\n  width: 10px;\n}\n.repricing-table thead tr th[data-v-84eaa828]:nth-child(2) {\n  width: 25%;\n}\n.repricing-table thead tr th[data-v-84eaa828]:nth-child(3) {\n  width: 10%;\n}\n.repricing-table thead tr th[data-v-84eaa828]:nth-child(4),\n.repricing-table thead tr th[data-v-84eaa828]:nth-child(5) {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n.repricing-table thead.total-head[data-v-84eaa828] {\n  font-size: 1.2em;\n}\n.repricing-table th[data-v-84eaa828] {\n  font-size: 1em;\n  font-weight: 900;\n}\n.repricing-table th[data-v-84eaa828],\n.repricing-table td[data-v-84eaa828] {\n  padding: 12px 15px;\n}\n.repricing-table tbody tr[data-v-84eaa828] {\n  border-bottom: 1px solid #dddddd;\n}\n.repricing-table tbody tr[data-v-84eaa828]:nth-of-type(even) {\n  background-color: #f3f3f3;\n}\n.repricing-table tbody tr[data-v-84eaa828]:last-of-type {\n  border-bottom: 2px solid #a0a0a0;\n}\n.repricing-table tfoot.tfoot-table[data-v-84eaa828] {\n  font-size: 1.1em;\n  font-weight: bolder;\n  color: #009879;\n}\n.repricing-table td.flex-end[data-v-84eaa828] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\ntable.commision-table[data-v-84eaa828] {\n  border-collapse: collapse;\n  margin: 25px 0;\n  font-size: 1.1em;\n  border-radius: 5px 5px 0 0;\n  overflow: hidden;\n  font-weight: 500;\n}\ntable.commision-table tbody[data-v-84eaa828] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 10px;\n}\ntable.commision-table tr[data-v-84eaa828] {\n  border-left: 4px solid #a0a0a0;\n  border-radius: 5px;\n}\ntable.commision-table tr td[data-v-84eaa828]:first-child {\n  padding-left: 10px;\n  width: 150px;\n}\ntable.commision-table tr td[data-v-84eaa828]:nth-child(2) {\n  width: 20px;\n}\ntable.commision-table tr td[data-v-84eaa828]:last-child {\n  min-width: 120px;\n  text-align: right;\n}\nbutton.btn-close-modal[data-v-84eaa828] {\n  padding: 8px;\n  border-radius: 100%;\n}\nbutton.btn-close-modal[data-v-84eaa828]:hover {\n  background: #a0a0a0;\n}\nbutton.btn-edit-repricing[data-v-84eaa828] {\n  padding: 3px 20px;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  background-color: #fff;\n  border: 1px solid rgb(79, 184, 72);\n  color: rgb(79, 184, 72);\n}\nbutton.btn-delete-repricing[data-v-84eaa828] {\n  padding: 3px 20px;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  background-color: #fff;\n  border: 1px solid rgb(255, 0, 0);\n  color: rgb(255, 0, 0);\n}\nbutton.btn-edit-repricing[data-v-84eaa828]:hover {\n  background-color: rgb(79, 184, 72);\n  color: #fff;\n  font-weight: 700;\n}\nbutton.btn-delete-repricing[data-v-84eaa828]:hover {\n  background-color: rgb(255, 0, 0);\n  color: #fff;\n  font-weight: 700;\n}\nbutton.btn-edit-check[data-v-84eaa828] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 3px 20px;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  background-color: #fff;\n  border: 1px solid rgb(79, 184, 72);\n  color: rgb(79, 184, 72);\n}\nbutton.btn-edit-check[data-v-84eaa828]:hover {\n  background-color: rgb(79, 184, 72);\n  color: #fff;\n  font-weight: 700;\n}\nbutton.btn-edit-wrong[data-v-84eaa828] {\n  padding: 3px 20px;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  background-color: #fff;\n  border: 1px solid rgb(255, 0, 0);\n  color: rgb(255, 0, 0);\n}\nbutton.btn-edit-wrong[data-v-84eaa828]:hover {\n  background-color: rgb(255, 0, 0);\n  color: #fff;\n  font-weight: 700;\n}\n.btn.btn-add[data-v-84eaa828] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 6px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-add[data-v-84eaa828]:hover {\n  background: #339c2b;\n}\n.btn.btn-submit[data-v-84eaa828] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-cancel[data-v-84eaa828] {\n  background: #a0a0a0;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-84eaa828]:hover {\n  background: #339c2b;\n}\n.btn.btn-cancel[data-v-84eaa828]:hover {\n  background: #888888;\n}\n.gap-10[data-v-84eaa828] {\n  gap: 10px;\n}\nspan.blue__color[data-v-84eaa828] {\n  color: #5499e4;\n}\n.repricing_box_date_time[data-v-84eaa828] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 70%;\n  padding: 10px 20px;\n  border-radius: 5px;\n  border: 1px solid #dddddd;\n  gap: 10px;\n  margin: 0 auto;\n}\n.repricing_box_date_time .date_time_box[data-v-84eaa828] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 60%;\n}\n.repricing_box_date_time .duration_box[data-v-84eaa828] {\n  width: 40%;\n}\ninput#repricing-date-time-input.field-input[data-v-84eaa828] {\n  border: none !important;\n  outline: none !important;\n}\n.repricingTime-box.rentTime-box[data-v-84eaa828] {\n  width: 100%;\n  height: 300px;\n}\n.repricing__profit__box[data-v-84eaa828] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 100%;\n  height: auto;\n}\nbutton svg[data-v-84eaa828] {\n  width: 20px;\n}\nspan.svg-empty-box svg[data-v-84eaa828] {\n  width: 80px;\n  color: #a0a0a0;\n}\nh5.label-empty-data[data-v-84eaa828] {\n  font-weight: 800;\n  color: #a0a0a0;\n}\nspan.green__color[data-v-84eaa828] {\n  color: #009879;\n}\n.text-checkbox[data-v-84eaa828] {\n  color: #4a4a4a;\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(604), __esModule: true };

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(605);
module.exports = __webpack_require__(1).Number.isInteger;


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', { isInteger: __webpack_require__(606) });


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(11);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPreBooking_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49837476_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPreBooking_vue__ = __webpack_require__(610);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49837476"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPreBooking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49837476_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPreBooking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("1e842c9d", content, true, {});

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".modal-body.repricing-modal[data-v-49837476]{padding:15px 20px}.btn.btn-submit[data-v-49837476]{background:#4fb848}.btn.btn-cancel[data-v-49837476],.btn.btn-submit[data-v-49837476]{font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-cancel[data-v-49837476]{background:#a0a0a0}.btn.btn-submit[data-v-49837476]:hover{background:#339c2b}.btn.btn-cancel[data-v-49837476]:hover{background:#888}.gap-10[data-v-49837476]{gap:10px}", "", {"version":3,"sources":["/app/src/components/shared/FormPreBooking.vue"],"names":[],"mappings":"AACA,6CACE,iBAAmB,CACpB,AACD,iCACE,kBAAoB,CAWrB,AACD,kEAXE,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CAcf,AAZD,iCACE,kBAAoB,CAWrB,AACD,uCACE,kBAAoB,CACrB,AACD,uCACE,eAAoB,CACrB,AACD,yBACE,QAAU,CACX","file":"FormPreBooking.vue","sourcesContent":["\n.modal-body.repricing-modal[data-v-49837476] {\n  padding: 15px 20px;\n}\n.btn.btn-submit[data-v-49837476] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-cancel[data-v-49837476] {\n  background: #a0a0a0;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-49837476]:hover {\n  background: #339c2b;\n}\n.btn.btn-cancel[data-v-49837476]:hover {\n  background: #888888;\n}\n.gap-10[data-v-49837476] {\n  gap: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"extraModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',[_vm._v("Pre Booking Components")]),_vm._v(" "),_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                      'field-error':
                        _vm.isSubmitted && !_vm.$v.modelBooking.name.required,
                    },attrs:{"placeholder":"","label":"label","options":_vm.bookingOption,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.label; }},on:{"input":function($event){return _vm.clearModelBooking()}},model:{value:(_vm.modelBooking.name),callback:function ($$v) {_vm.$set(_vm.modelBooking, "name", $$v)},expression:"modelBooking.name"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.modelBooking.name.required)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    Name is required\n                  ")]):_vm._e()],1),_vm._v(" "),(_vm.modelBooking.name && _vm.showQty)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelBooking.qty),expression:"modelBooking.qty"}],staticClass:"form-control numbers-only",class:{
                      'field-error':
                        _vm.isSubmitted && _vm.$v.modelBooking.qty.$error,
                    },attrs:{"type":"text","name":"quantity","placeholder":"Enter quantity"},domProps:{"value":(_vm.modelBooking.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelBooking, "qty", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.modelBooking.qty.$error)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    "+_vm._s(!_vm.$v.modelBooking.qty.minValue
                        ? "Minimum quantity must be 1"
                        : "Quantity is required")+"\n                  ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.modelBooking.name && _vm.showBuyingRate)?_c('div',{staticClass:"form-group"},[[_c('label',{staticClass:"required"},[_vm._v("Buying Rate")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#777"}},[_vm._v("(in local currency)")])],_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                      'field-error':
                        _vm.isSubmitted && _vm.$v.modelBooking.buyingRate.$error,
                    },attrs:{"autocomplete":"off","placeholder":"Enter buying rate","name":"selling","allow-negative":false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(_vm.modelBooking.buyingRate),callback:function ($$v) {_vm.$set(_vm.modelBooking, "buyingRate", $$v)},expression:"modelBooking.buyingRate"}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.modelBooking.buyingRate.$error)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    Buying rate is required\n                  ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.modelBooking.name)?_c('div',{staticClass:"form-group"},[[_c('label',{staticClass:"required"},[_vm._v("Selling Rate")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#777"}},[_vm._v("(in local currency)")])],_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                      'field-error':
                        _vm.isSubmitted && !_vm.$v.modelBooking.sellingRate.required,
                    },attrs:{"autocomplete":"off","placeholder":"Enter selling rate","name":"selling","allow-negative":_vm.modelBooking.name.toLowerCase() === 'markup'
                        ? true
                        : false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(_vm.modelBooking.sellingRate),callback:function ($$v) {_vm.$set(_vm.modelBooking, "sellingRate", $$v)},expression:"modelBooking.sellingRate"}}),_vm._v(" "),(
                      _vm.isSubmitted && !_vm.$v.modelBooking.sellingRate.required
                    )?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    Selling rate is required\n                  ")]):_vm._e()],2):_vm._e(),_vm._v(" "),_vm._m(0)])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-end gap-10 items-center"},[_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"reset"}},[_vm._v("Reset")]),_vm._v(" "),_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit"}},[_vm._v("Submit")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPostBooking_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ce0cfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPostBooking_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13ce0cfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPostBooking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ce0cfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPostBooking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(613);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("e5242996", content, true, {});

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".modal-body.repricing-modal[data-v-13ce0cfe]{padding:15px 20px}.btn.btn-submit[data-v-13ce0cfe]{background:#4fb848}.btn.btn-cancel[data-v-13ce0cfe],.btn.btn-submit[data-v-13ce0cfe]{font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-cancel[data-v-13ce0cfe]{background:#a0a0a0}.btn.btn-submit[data-v-13ce0cfe]:hover{background:#339c2b}.btn.btn-cancel[data-v-13ce0cfe]:hover{background:#888}.gap-10[data-v-13ce0cfe]{gap:10px}", "", {"version":3,"sources":["/app/src/components/shared/FormPostBooking.vue"],"names":[],"mappings":"AACA,6CACE,iBAAmB,CACpB,AACD,iCACE,kBAAoB,CAWrB,AACD,kEAXE,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CAcf,AAZD,iCACE,kBAAoB,CAWrB,AACD,uCACE,kBAAoB,CACrB,AACD,uCACE,eAAoB,CACrB,AACD,yBACE,QAAU,CACX","file":"FormPostBooking.vue","sourcesContent":["\n.modal-body.repricing-modal[data-v-13ce0cfe] {\n  padding: 15px 20px;\n}\n.btn.btn-submit[data-v-13ce0cfe] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-cancel[data-v-13ce0cfe] {\n  background: #a0a0a0;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-13ce0cfe]:hover {\n  background: #339c2b;\n}\n.btn.btn-cancel[data-v-13ce0cfe]:hover {\n  background: #888888;\n}\n.gap-10[data-v-13ce0cfe] {\n  gap: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"extraModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',[_vm._v("Post Booking Extra Services")]),_vm._v(" "),_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                      'field-error':
                        _vm.isSubmitted && !_vm.$v.modelBooking.name.required,
                    },attrs:{"placeholder":"","label":"label","options":_vm.bookingOption,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},on:{"input":function($event){return _vm.clearModelBooking()}},model:{value:(_vm.modelBooking.name),callback:function ($$v) {_vm.$set(_vm.modelBooking, "name", $$v)},expression:"modelBooking.name"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.modelBooking.name.required)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    Name is required\n                  ")]):_vm._e()],1),_vm._v(" "),(_vm.modelBooking.name && _vm.showQty)?_c('div',{staticClass:"form-group"},[[_c('label',{staticClass:"required"},[_vm._v("Quantity")]),_vm._v(" "),(_vm.showMinOnQty)?_c('span',{staticClass:"sts-danger"},[_vm._v("(Min.)")]):_vm._e()],_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelBooking.qty),expression:"modelBooking.qty"}],staticClass:"form-control numbers-only",class:{
                      'field-error':
                        _vm.isSubmitted && _vm.$v.modelBooking.qty.$error,
                    },attrs:{"type":"text","name":"quantity","placeholder":"Enter quantity"},domProps:{"value":(_vm.modelBooking.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelBooking, "qty", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.modelBooking.qty.$error)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    "+_vm._s(!_vm.$v.modelBooking.qty.minValue
                        ? "Minimum quantity must be 1"
                        : "Quantity is required")+"\n                  ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.modelBooking.name)?_c('div',{staticClass:"form-group"},[[_c('label',{staticClass:"required"},[_vm._v("Buying Rate")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#777"}},[_vm._v("(in local currency)")])],_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                      'field-error':
                        _vm.isSubmitted && !_vm.$v.modelBooking.buyingRate.required,
                    },attrs:{"autocomplete":"off","placeholder":"Enter buying rate","name":"buying","allow-negative":false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(_vm.modelBooking.buyingRate),callback:function ($$v) {_vm.$set(_vm.modelBooking, "buyingRate", $$v)},expression:"modelBooking.buyingRate"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.modelBooking.buyingRate.required)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    Buying rate is required\n                  ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.modelBooking.name)?_c('div',{staticClass:"form-group"},[[_c('label',{staticClass:"required"},[_vm._v("Selling Rate")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#777"}},[_vm._v("(in local currency)")])],_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                      'field-error':
                        _vm.isSubmitted && _vm.$v.modelBooking.sellingRate.$error,
                    },attrs:{"autocomplete":"off","placeholder":"Enter selling rate","name":"selling","allow-negative":false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(_vm.modelBooking.sellingRate),callback:function ($$v) {_vm.$set(_vm.modelBooking, "sellingRate", $$v)},expression:"modelBooking.sellingRate"}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.modelBooking.sellingRate.$error)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                    Selling rate is required\n                  ")]):_vm._e()],2):_vm._e(),_vm._v(" "),_vm._m(0)])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-end gap-10 items-center"},[_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"reset"}},[_vm._v("Reset")]),_vm._v(" "),_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit"}},[_vm._v("Submit")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalConfirmUpdate_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b31606_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalConfirmUpdate_vue__ = __webpack_require__(618);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77b31606"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalConfirmUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b31606_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalConfirmUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("21e5befd", content, true, {});

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".warn__icon[data-v-77b31606]{color:#eb0011}.warn__icon svg[data-v-77b31606]{width:100px;height:100px}.btn.btn-submit[data-v-77b31606]{background:#4fb848;font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-submit[data-v-77b31606]:hover{background:#339c2b}", "", {"version":3,"sources":["/app/src/components/shared/ModalConfirmUpdate.vue"],"names":[],"mappings":"AACA,6BACE,aAAe,CAChB,AACD,iCACE,YAAa,AACb,YAAc,CACf,AACD,iCACE,mBAAoB,AACpB,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CACf,AACD,uCACE,kBAAoB,CACrB","file":"ModalConfirmUpdate.vue","sourcesContent":["\n.warn__icon[data-v-77b31606] {\n  color: #eb0011;\n}\n.warn__icon svg[data-v-77b31606] {\n  width: 100px;\n  height: 100px;\n}\n.btn.btn-submit[data-v-77b31606] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-77b31606]:hover {\n  background: #339c2b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"repricingEditModal",staticClass:"modal fade",attrs:{"role":"dialog","id":"repricing-edit-modal"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"warn__icon"},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 512 512","enable-background":"new 0 0 512 512","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"fill":"currentColor","d":"M228.9,79.9L51.8,403.1C40.6,423.3,55.5,448,78.9,448h354.3c23.3,0,38.2-24.7,27.1-44.9L283.1,79.9\n\t\tC271.4,58.7,240.6,58.7,228.9,79.9z M273.6,214L270,336h-28l-3.6-122H273.6z M256,402.4c-10.7,0-19.1-8.1-19.1-18.4\n\t\ts8.4-18.4,19.1-18.4s19.1,8.1,19.1,18.4S266.7,402.4,256,402.4z"}})])])]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.message)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                    Cancel\n                  ")]),_vm._v(" "),(_vm.buttonProcess)?[_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                      Proceed\n                    ")])]:_vm._e()],2)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/fare-component";

/* harmony default export */ __webpack_exports__["a"] = ({
  getPreBookingComponent: function getPreBookingComponent() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/pre-booking").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getPostBookingComponent: function getPostBookingComponent() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/post-booking").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('section',{staticClass:"repricing-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"header--reservation-detail"},[_c('div',{staticClass:"header--reservation-box"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb mb-35 pz"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":_vm.$route.path.includes('tenant')
                          ? ("/job/tenant/" + (_vm.$route.params.id))
                          : ("/reservation/inquiry/" + (_vm.$route.params.id))}},[_vm._v("\n                      "+_vm._s(_vm.$route.path.includes("tenant")
                          ? "Tenant Job Detail"
                          : "Reservation Summary")+"\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                    Repricing\n                  ")])])]),_vm._v(" "),_c('h4',[_vm._v("Booking Details")]),_vm._v(" "),_c('div',{staticClass:"table-legend"},[_c('ul',[(_vm.isAirportTransfer)?_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer\n                  ")]):_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking")])])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Payment Status")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[(_vm.reservation.paymentStatus === 'Complete')?_c('span',{staticClass:"--green35"},[_vm._v("Completed")]):_c('span',{staticClass:"sts-danger"},[_vm._v(_vm._s(_vm.humanize(_vm.reservation.paymentStatus)))])])]),_vm._v(" "),(_vm.reservation.paymentMethodDescription)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Payment Method")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.reservation.paymentMethodDescription))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Code")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.reservation.code))])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Date")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.reservation.reservationDate.stringFullDate)+" ")])])])])]),_vm._v(" "),_c('div',{staticClass:"service-type-wrapper"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"btn-group mb-15",attrs:{"role":"group","aria-label":"..."}},[_c('button',{staticClass:"btn btn-default",class:{
                  'btn-active': _vm.model.serviceType === 'AirportTransfer',
                },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType('AirportTransfer')}}},[_vm._v("\n                Airport Transfer\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.model.serviceType === 'Rental' },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType('Rental')}}},[_vm._v("\n                Hourly\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"search-form-wrapper",attrs:{"id":"search-form-wrapper"}},[_c('div',{staticClass:"search-row-wrapper"},[_c('div',{staticClass:"pick-up-location-wrapper",style:(!_vm.differentLocation &&
                _vm.model.serviceType === 'Rental' &&
                'width: 100%')},[_c('label',[_vm._v("Pick-up Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pickUpLocation.name),expression:"model.pickUpLocation.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"pick-up-location"},domProps:{"value":(_vm.model.pickUpLocation.name)},on:{"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.showDropOffLocation)?_c('div',{staticClass:"drop-off-location-wrapper"},[_c('label',[_vm._v("Drop-off Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.dropOffLocation.name),expression:"model.dropOffLocation.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"drop-off-location"},domProps:{"value":(_vm.model.dropOffLocation.name)},on:{"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"search-row-wrapper"},[_c('div',{staticClass:"pick-up-date-time-wrapper",style:(_vm.model.serviceType === 'AirportTransfer' && 'width: 100%')},[_c('label',[_vm._v("Pick-up Date & Time")]),_vm._v(" "),[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"repricing-date-time","color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":"","no-clear-button":""},model:{value:(_vm.model.pickUpDate.date),callback:function ($$v) {_vm.$set(_vm.model.pickUpDate, "date", $$v)},expression:"model.pickUpDate.date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"repricing-time","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":_vm.model.serviceType === 'AirportTransfer' ? 5 : 15,"overlay":"","only-time":"","no-label":"","no-header":"","no-button":"","no-clear-button":""},model:{value:(_vm.model.pickUpDate.time),callback:function ($$v) {_vm.$set(_vm.model.pickUpDate, "time", $$v)},expression:"model.pickUpDate.time"}})],1)])]],2),_vm._v(" "),(_vm.model.serviceType === 'Rental')?_c('div',{staticClass:"drop-off-date-time-wrapper"},[[_c('label',{attrs:{"for":"duration"}},[_vm._v("Duration")]),_vm._v(" "),[_c('div',{staticClass:"wrap__input-box",attrs:{"id":"rentTime-wrapper"}},[_c('div',{staticClass:"col-sm-12"},[_c('i',{staticClass:"ic-time plz"}),_vm._v(" "),_c('span',{staticClass:"searchBox__input"},[_vm._v("\n                        "+_vm._s(_vm.model.durationInHour)+"\n                        "+_vm._s(_vm.model.durationInHour === 1 ? "Hour" : "Hours")+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"repricingTime-box rentTime-box hidden"},[_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('h5',[_vm._v("\n                              Duration\n                              "),_c('span',[_vm._v(_vm._s(_vm.model.durationInHour)+"\n                                "+_vm._s(_vm.model.durationInHour === 1
                                    ? "Hour"
                                    : "Hours"))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"col-sm-12 plz list-time"},[_c('ul',{staticClass:"picktime-hour",attrs:{"id":"picktime-hour-item"}},_vm._l((_vm.durationValue),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                                        selected:
                                          item === _vm.model.durationInHour,
                                      },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickDurationPicker(item)}}},[_vm._v(_vm._s(item)+"\n                                      "+_vm._s(item === 1 ? "Hour" : "Hours"))])])}),0)])])])])])])])]]],2):_vm._e()]),_vm._v(" "),(_vm.model.serviceType === 'Rental')?[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.differentLocation),expression:"differentLocation"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.differentLocation,"checked":Array.isArray(_vm.differentLocation)?_vm._i(_vm.differentLocation,_vm.differentLocation)>-1:(_vm.differentLocation)},on:{"change":function($event){var $$a=_vm.differentLocation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.differentLocation,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.differentLocation=$$a.concat([$$v]))}else{$$i>-1&&(_vm.differentLocation=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.differentLocation=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 v-align-middle text-checkbox"},[_vm._v("\n                Drop off at different location\n              ")])])]:_vm._e()],2),_vm._v(" "),(_vm.preBookingComponents.length)?_c('div',{staticClass:"col-sm-12 mt-10"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',[_vm._v("Pre Booking Components")]),_vm._v(" "),_c('button',{staticClass:"btn btn-add",on:{"click":_vm.openModalPreBooking}},[_vm._v("\n              Add Pre Booking\n            ")])]),_vm._v(" "),_c('table',{staticClass:"repricing-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("No")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Qty")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Buying ("+_vm._s(_vm.currencyCode)+")")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Selling ("+_vm._s(_vm.currencyCode)+")")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.preBookingComponents),function(component,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(component.name))]),_vm._v(" "),(!component.isEdited)?[_c('td',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(component.qty ? component.qty : "-")+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(component.buyingRate || component.sellingRate === 0
                        ? _vm.$currencyFormat(
                            component.currency,
                            component.buyingRate
                          )
                        : "-")+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(component.sellingRate || component.sellingRate === 0
                        ? _vm.$currencyFormat(
                            component.currency,
                            component.sellingRate
                          )
                        : "-")+"\n                  ")]),_vm._v(" "),(!component.isEdited)?_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn-edit-repricing",on:{"click":function($event){return _vm.onEditComponent(component, index)}}},[_vm._v("\n                      Edit\n                    ")]),_vm._v(" "),(component.name.toLowerCase() !== 'base')?_c('button',{staticClass:"btn-delete-repricing",on:{"click":function($event){return _vm.deleteFareComponent(index)}}},[_vm._v("\n                      Delete\n                    ")]):_vm._e()]):_vm._e()]:[_c('td',{staticClass:"text-center"},[(_vm.checkQty(index, _vm.preBookingText))?[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(component.qty),expression:"component.qty",modifiers:{"number":true}}],staticClass:"form-control-repricing numbers-only",attrs:{"type":"number","min":"1"},domProps:{"value":(component.qty)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(component, "qty", _vm._n($event.target.value))},function($event){return _vm.onChangeQty(
                            index,
                            _vm.preBookingComponents,
                            _vm.masterPreBookingComponents
                          )}],"blur":function($event){return _vm.$forceUpdate()}}})]:[_c('span',[_vm._v("-")])]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.checkBuyingRate(index, _vm.preBookingText))?[_c('currency-input',{ref:"buyingRate",refInFor:true,staticClass:"form-control-repricing",attrs:{"autocomplete":"off","placeholder":"Enter buying rate","name":"buying","allow-negative":false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(component.buyingRate),callback:function ($$v) {_vm.$set(component, "buyingRate", _vm._n($$v))},expression:"component.buyingRate"}})]:[_c('span',[_vm._v("-")])]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.checkSellingRate(index, _vm.preBookingText))?[_c('currency-input',{staticClass:"form-control-repricing",attrs:{"autocomplete":"off","placeholder":"Enter selling rate","name":"selling","allow-negative":component.name.toLowerCase() === 'markup'
                            ? true
                            : false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(component.sellingRate),callback:function ($$v) {_vm.$set(component, "sellingRate", _vm._n($$v))},expression:"component.sellingRate"}})]:[_c('span',[_vm._v("-")])]],2),_vm._v(" "),_c('td',{staticClass:"d-flex justify-center items-center"},[_c('button',{staticClass:"btn-edit-check",on:{"click":function($event){return _vm.validateConfirmEdit(index, _vm.preBookingText)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69L432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z","fill":"currentColor"}})])])])]],2)}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',[_vm._v("Post Booking Extra Services")]),_vm._v(" "),_c('button',{staticClass:"btn btn-add",on:{"click":_vm.openModalPostBooking}},[_vm._v("\n              Add Post Booking\n            ")])]),_vm._v(" "),_c('table',{staticClass:"repricing-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("No")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Qty")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Buying ("+_vm._s(_vm.currencyCode)+")")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Selling ("+_vm._s(_vm.currencyCode)+")")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),(_vm.extraServices.length)?_c('tbody',_vm._l((_vm.extraServices),function(extra,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(extra.name === "Fare Parking"
                      ? "Parking"
                      : extra.name === "Fare Toll"
                      ? "Tolls"
                      : extra.name)+"\n                ")]),_vm._v(" "),(!extra.isEdited)?[_c('td',{staticClass:"text-center"},[(extra.qty)?[_vm._v("\n                      "+_vm._s(extra.qty)+"\n                      "),_c('span',{staticClass:"green__color"},[_vm._v(_vm._s(extra.name === "Arrival Waiting Time" ||
                        extra.name === "Waiting Time"
                          ? "Min"
                          : null))])]:[_vm._v("-")]],2),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(extra.buyingRate
                        ? _vm.$currencyFormat(extra.currency, extra.buyingRate)
                        : "-")+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(extra.sellingRate || extra.sellingRate === 0
                        ? _vm.$currencyFormat(extra.currency, extra.sellingRate)
                        : "-")+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn-edit-repricing",on:{"click":function($event){return _vm.onEditExtra(extra, i)}}},[_vm._v("\n                      Edit\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn-delete-repricing",on:{"click":function($event){return _vm.deleteExtraService(i)}}},[_vm._v("\n                      Delete\n                    ")])])]:[_c('td',[(_vm.checkQty(i, _vm.postBookingText))?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(extra.qty),expression:"extra.qty"}],staticClass:"form-control-repricing numbers-only",attrs:{"type":"number","min":"1"},domProps:{"value":(extra.qty)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(extra, "qty", $event.target.value)},function($event){return _vm.onChangeQty(i, _vm.extraServices, _vm.masterExtraServices)}]}})]:[_c('span',[_vm._v("-")])]],2),_vm._v(" "),_c('td',[(_vm.checkBuyingRate(i, _vm.postBookingText))?[_c('currency-input',{staticClass:"form-control-repricing",attrs:{"autocomplete":"off","placeholder":"Enter buying rate","name":"buying","allow-negative":false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(extra.buyingRate),callback:function ($$v) {_vm.$set(extra, "buyingRate", $$v)},expression:"extra.buyingRate"}})]:[_c('span',[_vm._v("-")])]],2),_vm._v(" "),_c('td',[(_vm.checkSellingRate(i, _vm.postBookingText))?[_c('currency-input',{staticClass:"form-control-repricing",attrs:{"autocomplete":"off","placeholder":"Enter selling rate","name":"selling","allow-negative":false,"currency":null,"locale":_vm.currencyLocale,"precision":_vm.currencyPrecision},model:{value:(extra.sellingRate),callback:function ($$v) {_vm.$set(extra, "sellingRate", $$v)},expression:"extra.sellingRate"}})]:[_c('span',[_vm._v("-")])]],2),_vm._v(" "),_c('td',{staticClass:"d-flex justify-center items-center"},[_c('button',{staticClass:"btn-edit-check",on:{"click":function($event){return _vm.validateConfirmEdit(i, _vm.postBookingText)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69L432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z","fill":"currentColor"}})])])])]],2)}),0):_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"6"}},[_c('span',{staticClass:"svg-empty-box"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M12 10c4.418 0 8-1.79 8-4s-3.582-4-8-4s-8 1.79-8 4s3.582 4 8 4zm6.328.17A7.61 7.61 0 0 0 20 9.053v3.204a5.477 5.477 0 0 0-4.02-1.233a11.687 11.687 0 0 0 2.348-.854zM11 16.5a5.502 5.502 0 0 0 3.831 5.242c-.88.167-1.834.258-2.831.258c-4.418 0-8-1.79-8-4V9.053a7.61 7.61 0 0 0 1.672 1.117C7.37 11.018 9.608 11.5 12 11.5c.958 0 1.892-.077 2.777-.225A5.502 5.502 0 0 0 11 16.5zm5.5 4.5a4.48 4.48 0 0 0 2.607-.832l2.613 2.612a.75.75 0 1 0 1.06-1.06l-2.612-2.613A4.5 4.5 0 1 0 16.5 21zm0-1.5a3 3 0 1 1 0-6a3 3 0 0 1 0 6z","fill":"currentColor"}})])])]),_vm._v(" "),_c('h5',{staticClass:"label-empty-data"},[_vm._v("None.")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('h4',[_vm._v("Total")]),_vm._v(" "),_c('table',{staticClass:"repricing-table"},[_vm._m(2),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("- Pre Booking (Subtotal)")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currencyCode)+"\n                  "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.preBookingBuyingTotal))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currencyCode)+"\n                  "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.preBookingSellingTotal))+"\n                ")])]),_vm._v(" "),(_vm.extraServices.length)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("- Post Booking (Subtotal)")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currencyCode)+"\n                  "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.postBookingBuyingTotal))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currencyCode)+"\n                  "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.postBookingSellingTotal))+"\n                ")])]):_vm._e()]),_vm._v(" "),_c('tfoot',{staticClass:"tfoot-table"},[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("TOTAL")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currencyCode)+"\n                  "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.grandBuyingTotal))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currencyCode)+"\n                  "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.grandSellingTotal))+"\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"repricing__profit__box"},[_c('div',{staticClass:"col-md-9 col-sm-12"},[_c('h4',[_vm._v("Commission")]),_vm._v(" "),_c('table',{staticClass:"commision-table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Booker")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(
                          _vm.currencyCode,
                          _vm.commission.booker && this.commission.booker.amount
                            ? this.commission.booker.amount
                            : 0
                        ))+"\n                    ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Operator")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(
                          _vm.currencyCode,
                          _vm.commission.operator &&
                            this.commission.operator.amount
                            ? this.commission.operator.amount
                            : 0
                        ))+"\n                    ")])])])]),_vm._v(" "),_c('h4',[_vm._v("Profit")]),_vm._v(" "),_c('table',{staticClass:"commision-table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Total Selling")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.grandSellingTotal))+"\n                    ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Buying")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.grandBuyingTotal))+"\n                    ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Commission")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.totalCommission))+"\n                    ")])]),_vm._v(" "),_c('tr',{staticStyle:{"border-left":"none","border-bottom":"2px dashed #a0a0a0"}}),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Profit")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(_vm.currencyCode, _vm.profitTotal))+"\n                    ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-end items-center gap-10"},[_c('router-link',{attrs:{"to":_vm.$route.path.includes('tenant')
                  ? '/job/tenant/' + _vm.$route.params.id
                  : '/reservation/inquiry/' + _vm.$route.params.id}},[_c('button',{staticClass:"btn btn-cancel"},[_vm._v("Cancel")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-submit",attrs:{"disabled":!_vm.preBookingEdited || !_vm.postBookingEdited},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_vm._v("\n              Submit\n            ")])],1)])])])]):_vm._e(),_vm._v(" "),_c('FormPreBooking',{on:{"submit":_vm.onSubmitComponent}}),_vm._v(" "),_c('FormPostBooking',{on:{"submit":_vm.onSubmitComponent}}),_vm._v(" "),_c('ModalConfirmUpdate',{on:{"submit":_vm.submitFromModal}}),_vm._v(" "),_c('ConfirmModal',{attrs:{"id":'ConfirmationModal',"header":'Confirmation',"content":"The service type has been changed. Are you sure you wish to proceed?","cancel-label":'No',"submit-label":'Yes',"color":'confirm-icon',"icon":'ic-check'},on:{"submit":function($event){return _vm.onSubmit(true)}}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-pickupResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-dropoffResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Name")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Buying")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Selling")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_Repricing__ = __webpack_require__(373);
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Repricing: __WEBPACK_IMPORTED_MODULE_0__components_shared_Repricing__["default"]
  },
  updated: function updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("tenant-job-browser-link");
  }
});

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Repricing')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.0116b3923ca486cdbaba.js